import React from 'react';
import PropTypes from 'prop-types';
import styles from './QuestionKeyWordListDisplay.scss';
import scorableItemNumberingService from '../../services/questionView/ScorableItemNumberingService';
import navigationService from '../../services/NavigationService';
import keywordService from '../../services/KeywordService';
import questionReader from '../../store/readHelpers/QuestionReader';
import settingsReader from '../../store/readHelpers/SettingsReader';

const QuestionKeyWord = (props) => {
    const { question, response, sectionId, currentScorableItem } = props;

    const placeholderNumber = scorableItemNumberingService.getInteractionNumber(question.contentRevisionId, response.identifier);
    const key = `keyword-${placeholderNumber}`;
    const selected = currentScorableItem === parseInt(placeholderNumber, 10);
    const classNamesList = [styles.keyWordOption];
    const hasWordFormationMetadata = settingsReader.shouldUsePaperBasedWordFormation(question);

    if (selected) {
        classNamesList.push(styles.selectedKeyWord);
    }

    const handleClick = () => {
        const orderNumber = Number.parseInt(placeholderNumber, 10);

        if (questionReader.isGapMatchQuestion(question)) {
            setTimeout(() => navigationService.scrollToGapInput(question.contentRevisionId, orderNumber).catch(console.error));
        } else {
            navigationService.scrollToQuestion(sectionId, question.contentRevisionId, orderNumber, 0, 300);
        }

        setTimeout(() => {
            navigationService.navigateToScorableItem(sectionId, question.contentRevisionId, orderNumber);
        }, 0);
    };

    const separator = hasWordFormationMetadata ? '\u00A0\u00A0\u00A0' : '. ';

    return (
        <li id={key}>
            <button className={classNamesList.join(' ')} tabIndex="0" onClick={handleClick}>
                {placeholderNumber}{separator}{keywordService.parseKeyword(response)}
            </button>
        </li>
    );
};

QuestionKeyWord.propTypes = {
    currentScorableItem: PropTypes.number,
    question: PropTypes.object.isRequired,
    response: PropTypes.object.isRequired,
    sectionId: PropTypes.number.isRequired,
};

export default QuestionKeyWord;
